export default "__VITE_ASSET__19c6c65b__"